import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";

export const mapAdminCityService = {
  getAllCountsByMappedCities,
  userMapCityDetails,
};
const baseUrl = config.apiGateway.baseUrl;
function getAllCountsByMappedCities(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAllCountsByMappedCities/`,
    requestOptions
  ).then(handleResponse);
}
function userMapCityDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/userMapCityDetails/`, requestOptions).then(
    handleResponse
  );
}
